import { Route, Routes, useNavigate } from 'react-router';
import './App.css';
import Portfolio from './featchers/portfolio/Portfolio';
import PhotoPostsAdmin from './components/PhotoPostsAdmin';
import Login from './components/Login';

function App() {
  const navigate = useNavigate()
  const onLoginSuccess = (token) => {
    sessionStorage.setItem('token', token)
    navigate('/dashboard')
  }

  return (
    <div className="App">
        <Routes>
          <Route path='/' element={<></>} />
          <Route path='/gallery/:id' element={<Portfolio />} />
          <Route path='/login' element={<Login onLoginSuccess={onLoginSuccess} />} />
          <Route path='/dashboard' element={<PhotoPostsAdmin />} />
        </Routes>
        
    </div>
  );
}

export default App;
